import { useEffect } from "react";

export const SITE_URL = "https://arthainsurance.com";

export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;
    let tag = document.getElementById(id);
    if (!tag) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = id;
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(data);
    return () => { tag.remove(); };
  }, [id, data]);
}

export const AGENCY_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "InsuranceAgency",
  name: "Artha Insurance LLC",
  description: "Independent property and casualty insurance agency in Frisco, Texas, serving North Texas small business owners and homeowners.",
  url: "https://arthainsurance.com",
  logo: "https://arthainsurance.com/artha-logo.png",
  telephone: "+1-469-815-3491",
  email: "info@arthainsurance.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "12800 WestRidge Blvd, Ste 271",
    addressLocality: "Frisco",
    addressRegion: "TX",
    postalCode: "75035",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "City", name: "Frisco" },
    { "@type": "City", name: "Plano" },
    { "@type": "City", name: "McKinney" },
    { "@type": "City", name: "Allen" },
    { "@type": "City", name: "Prosper" },
    { "@type": "City", name: "Celina" },
    { "@type": "City", name: "Little Elm" },
    { "@type": "City", name: "The Colony" },
    { "@type": "AdministrativeArea", name: "Dallas–Fort Worth metroplex" },
    { "@type": "State", name: "Texas" },
  ],
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:30",
    closes: "17:30",
  },
  founder: { "@type": "Person", name: "Sreenivas Palla", jobTitle: "Insurance agent, Texas CPA" },
};

export function serviceSchema({ name, description, path }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name: `${name} — Artha Insurance, Frisco TX`,
    description,
    url: `${SITE_URL}${path}`,
    provider: { "@type": "InsuranceAgency", name: "Artha Insurance LLC", telephone: "+1-469-815-3491" },
    areaServed: { "@type": "State", name: "Texas" },
  };
}

export function faqSchema(pairs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: pairs.map(([q, a]) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map(([name, path], i) => ({
      "@type": "ListItem",
      position: i + 1,
      name,
      item: `${SITE_URL}${path}`,
    })),
  };
}
